import React, { useState, useEffect } from 'react';

// Hooks de dados
export { default as useSalon } from './useSalon';
export { default as useServices } from './useServices';
export { default as useProfessionals } from './useProfessionals';
export { default as useAppointments } from './useAppointments';
export { default as useCategories } from './useCategories';
export { useNotificationCounts } from './useNotificationCounts';
export { useUserPreferences } from './useUserPreferences';
export { useConfirmations } from './useConfirmations';
export { useWhatsAppTemplates } from './useWhatsAppTemplates';
export { default as useAppointmentValues } from './useAppointmentValues';
export { default as useProfessionalUtils } from './useProfessionalUtils';

// Hooks de agendamento e disponibilidade
export { useAvailabilityQuery } from './useAvailabilityQuery';
export { useBookingMutation } from './useBookingMutation';
export { useServiceSelection } from './useServiceSelection';
export { useDateTimeSelection } from './useDateTimeSelection';
export { useClientForm } from './useClientForm';

// Hooks modais e UI
export { default as useDragAndDrop } from './useDragAndDrop';
export { default as useSafeAreaInsets } from './useSafeAreaInsets';
export { default as useModalControls } from './useModalControls';
export { default as useAppointmentModal } from './useAppointmentModal';

// Hooks relacionados à timeline
export { default as useTimelineEvents } from './useTimelineEvents';
export { default as useTimelineResources } from './useTimelineResources';
export { default as useAppointmentActions } from './useAppointmentActions';
export { default as useTimeBlocking } from './useTimeBlocking';
export { default as useTimelineNavigation } from './useTimelineNavigation';
export { default as useUpcomingAppointments } from './useUpcomingAppointments';
export { default as useTimelineTouchNavigation } from './useTimelineTouchNavigation';

// Utilitários de formatação
export { formatTimeDistance, formatHourMinute, formatDate, formatDateTime } from '../utils/formatTime';

// Hook para detectar tamanho da janela
export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    
    window.addEventListener("resize", handleResize);
    handleResize();
    
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  
  return windowSize;
}; 